// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"bf9d8ba8","419":"a235323a","490":"48e5f985","720":"519c8592","897":"7b6753f0"}[chunkId] + ".chunk.css";
};